export default {"src":"/_next/static/media/instacart.2c42f8fd.svg","height":80,"width":180,"blurWidth":0,"blurHeight":0};